import React, { Component } from 'react';
import { action, observable, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import BarGraph from "./components/BarGraph";
import Page from "./components/Page/Page";
import { withRouter, Redirect } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import EventIcon from '@material-ui/icons/Event';
import Breadcrumbs from './components/Breadcrumbs';
import Content from './components/Content/Content';
import utils, { shallowDiffers, getEuros, getCents } from './utils';
import RefreshButton from './components/RefreshButton/RefreshButton';
import NoData from './components/NoData';

@inject('tasevastaavaaStore', 'receiptStore', 'routing')
@observer
class ReceiptList extends Component {


  componentDidMount() {
    this.props.tasevastaavaaStore.resetCategoryLimits();
    this.props.tasevastaavaaStore.fetchReceipts(this.props.account, this.props.month);
  }

  // Upgraded from componentWillReceiveProps
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.month === prevProps.month && !shallowDiffers(prevProps.account, this.props.account)) {
      return;
    }

    this.props.tasevastaavaaStore.resetCategoryLimits();
    this.props.tasevastaavaaStore.fetchReceipts(this.props.account, this.props.month);
  }

  render() {
    const { tasevastaavaaStore, receiptStore } = this.props;

    return (
      <Content
        loading={tasevastaavaaStore.isLoadingAccounts}
        loadingClass="padding-sm"
        error={tasevastaavaaStore.errorReceipts}
        errorClass="padding-sm"
      //empty={tasevastaavaaStore.account && !tasevastaavaaStore.account.length}       
      >
        <span className="margin-null" elevation={3}>
          <ProfitRow
            name='Avaava'
            accountNumber=''
            sum={tasevastaavaaStore.avaavatase}
          />
        </span>

        {
          tasevastaavaaStore.account &&
          tasevastaavaaStore.account.map((category, idx) =>
            <div key={idx}>
              <div className="receipt-category">
                {category.name}
              </div>
              {
                category.items.slice(0, tasevastaavaaStore.categoryLimits.get(idx) || 5)
                  .map((receipt, ridx) =>
                    <div
                      key={ridx}
                      className="clickable"
                      onClick={() => receiptStore.showReceipt(receipt, category)}
                    >
                      <ProfitRow
                        name={receipt.SELITE}
                        identifier={receipt.TOSITENUMERO}
                        date={utils.ymd2dmy(receipt.PAIVAMAARA)}
                        sum={-tasevastaavaaStore.sum(receipt)}
                      />
                    </div>
                  )
              }

              {
                tasevastaavaaStore.loadingCategories.has([this.props.tasevastaavaaStore.profitToken, this.props.account.TILINRO, category.id, this.props.month].join('.')) ?
                  <div style={{ padding: 5, display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress size={50} />
                  </div> :

                  category.items.length > (tasevastaavaaStore.categoryLimits.get(idx) || 5) ?
                    <div
                      className="clickable"
                      onClick={() => tasevastaavaaStore.showMore(this.props.account, this.props.month, category, idx)}
                    >
                      <div className="profitrow">
                        <div className="text-center">
                          Näytä enemmän
                    </div>
                      </div>
                    </div> :

                    !category.hasAll &&
                    <div
                      className="clickable"
                      onClick={() => tasevastaavaaStore.fetchMore(this.props.account, this.props.month, category, idx)}
                    >
                      <div className="profitrow">
                        <div className="text-center">
                          Hae enemmän
                    </div>
                      </div>
                    </div>
              }
            </div>
          )
        }
      </Content>
    );
  }
}

const ProfitRow = ({ accountNumber, name, identifier, date, sum }) => (
  <div className="profitrow">
    <div className="profitrow-row">
      <span className="profitrow-title">
        <span className="profitrow-accountnumber">{accountNumber} </span>
        {name}
      </span>
      <span className="profitrow-id">
        {identifier && '#' + identifier}
      </span>
    </div>
    <div className="profitrow-row">
      <span className="profitrow-date">
        {date}
      </span>
      <span className="profitrow-sum">
        {getEuros(sum)}
        <span className="sumrow-cents">
          {getCents(sum)} </span><span className="profitrow-sum">&nbsp;€</span>

      </span>
    </div>
  </div>
);

@inject('authStore', 'tasevastaavaaStore', 'routing', 'tilikausiStore')
@withRouter
@observer
class Tasevastaavaa extends Component {
  @observable menuAnchor;

  constructor() {
    super();
    makeObservable(this);
  }

  @action.bound
  showTilikaudet(e) {
    this.menuAnchor = e.currentTarget;
  }

  @action.bound
  hideTilikaudet() {
    this.menuAnchor = null;
  }

  selectTilikausi = (tilikausi) => {
    this.hideTilikaudet();
    this.props.tilikausiStore.selectTilikausi(tilikausi);
    this.props.tasevastaavaaStore.fetch();
  };


  componentDidMount() {
    const { tasevastaavaaStore, routing } = this.props;

    if (routing.location.pathname === '/tasevastaavaa') {
      tasevastaavaaStore.resetScroll();
    }
    this.props.tasevastaavaaStore.fetch();
  }
  /* Piirretään tasegrafiikka jne */
  render() {
    const { authStore, tasevastaavaaStore } = this.props;

    return (
      tasevastaavaaStore.invalidHash ?
        <Redirect to="/tasevastaavaa" /> :
        <Page
          title={'Tase ' + tasevastaavaaStore.timespan}
          forbidden={!tasevastaavaaStore.hasModule}
          error={tasevastaavaaStore.error}
          loading={tasevastaavaaStore.isLoadingProfits}
          onRetry={tasevastaavaaStore.fetch}
          contentRef={el => tasevastaavaaStore.pageContentRef = el}
          scrollTop={tasevastaavaaStore.scrollTop}
          actions={
            <div className="row">
              {
                authStore.currentCompany.tilikaudet &&
                <IconButton
                  color="inherit"
                  onClick={this.showTilikaudet}
                >
                  <EventIcon />
                </IconButton>
              }

              <RefreshButton
                loading={tasevastaavaaStore.isLoadingProfitsBackground}
                onClick={tasevastaavaaStore.refresh}
              />
            </div>
          }
        >
          {<div>
            {authStore.currentCompany.tilikaudet &&
              <Menu
                anchorEl={this.menuAnchor}
                open={!!this.menuAnchor}
                onClose={this.hideTilikaudet}
              >
                {
                  authStore.currentCompany.tilikaudet.map(tilikausi =>
                    <MenuItem
                      key={tilikausi.TILIKAUSIID}
                      onClick={() => this.selectTilikausi(tilikausi)}
                    >
                      {utils.ymd2dmy(tilikausi.ALKU)} - {utils.ymd2dmy(tilikausi.LOPPU)}
                    </MenuItem>
                  )
                }
              </Menu>
            }
            {tasevastaavaaStore.noData ? <NoData /> : <div>
              <Breadcrumbs data={tasevastaavaaStore.computered.crumbs} />

              <Card style={{ height: 200 }} className="margin-sm" elevation={3}>
                {
                  tasevastaavaaStore.graph &&
                  <BarGraph
                    hideY
                    noLegend
                    data={tasevastaavaaStore.graph.values}
                    xKey="month"
                    values={tasevastaavaaStore.graph.keys}
                    selected={tasevastaavaaStore.selectedMonth}
                    onSelect={tasevastaavaaStore.onMonthSelect}
                    labelFormatter={tasevastaavaaStore.kirjauskausiToMonthName}
                  />
                }
              </Card>

              <Card className="margin-md-vert" elevation={3}>
                <div className="sumrow">
                  <div>
                    <span className="sumrow-title">
                      <span className="sumrow-accountnumber">{tasevastaavaaStore.filteredBranch.TILINRO} </span>
                      {tasevastaavaaStore.filteredBranch.NIMI}
                    </span>
                    <br />
                    <span className="sumrow-date">
                      {tasevastaavaaStore.paattyvatasemonthText}
                    </span>
                  </div>

                  <div className="text-right">
                    <span className="sumrow-sum">
                      {getEuros(tasevastaavaaStore.paattyvatase)}
                      <span className="sumrow-cents">
                        {getCents(tasevastaavaaStore.paattyvatase)} </span><span className="sumrow-sum">&nbsp;€</span>
                    </span>
                  </div>
                </div>
              </Card>

              <Card className="margin-sm" elevation={3}>

                {
                  tasevastaavaaStore.filteredBranch &&
                    tasevastaavaaStore.filteredBranch.TILINRO ?
                    <ReceiptList
                      account={tasevastaavaaStore.filteredBranch}
                      month={tasevastaavaaStore.selectedMonth}
                    /> :

                    tasevastaavaaStore.filteredBranch.children ?
                      tasevastaavaaStore.filteredBranch.children.map((account, idx) =>
                        <div
                          key={idx}
                          className="clickable"
                          onClick={() => tasevastaavaaStore.drill(account, idx)}
                        >
                          <ProfitRow
                            name={account.NIMI}
                            accountNumber={account.TILINRO}
                            sum={tasevastaavaaStore.sum(account)}
                          />
                        </div>
                      ) :
                      null
                }
              </Card>
            </div>}
          </div>}
        </Page>
    );
  }
}

export default Tasevastaavaa;
